import React, { useRef, useEffect, useState } from "react";

const useImageLoadDone = (src: string) => {
  const currRef = useRef<{
    src: string;
    hasLoaded: boolean;
    image?: HTMLImageElement;
  }>({
    src: "",
    hasLoaded: false,
  });
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);

  useEffect(() => {
    // once load is done just update state
    if (currRef.current.hasLoaded) {
      setHasLoaded(true);
    } else {
      const image = new globalThis.Image();

      const onLoadOrError = () => {
        setHasLoaded(true);
        currRef.current.hasLoaded = true;
      };

      image.onload = onLoadOrError;
      image.onerror = onLoadOrError;

      image.src = src;
    }
  }, []);

  // a kind of a hack which increase performance of image onload
  // just start image load before when first render component
  if (src !== currRef.current.src) {
    const image = new globalThis.Image();

    image.src = src;

    const onLoadOrError = () => {
      currRef.current.hasLoaded = true;
    };

    image.onload = onLoadOrError;
    image.onerror = onLoadOrError;

    currRef.current = {
      src,
      image,
      hasLoaded: false,
    };
  }

  return hasLoaded;
};

export default useImageLoadDone;
